"use strict";module.exports=function t(e){return new t.InputMask(e,arguments.length>1&&void 0!==arguments[1]?arguments[1]:{})};
//# sourceMappingURL=holder.js.map
